// Minimal ABI for UsdtServiceEscrow (USDT credits)
export const USDT_ESCROW_ABI = [
  {
    inputs: [],
    name: 'USDT',
    outputs: [{ internalType: 'contract IERC20', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'availableBalance',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'reservedBalance',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
    name: 'deposit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

// Set after deployment (BSC)
export const USDT_ESCROW_ADDRESS = process.env.REACT_APP_USDT_ESCROW_ADDRESS || '';

// V2 escrow (Phase 2) — same minimal ABI; new deposits land here so user
// credits accumulate alongside the on-chain refund pool. The v1 contract
// continues to back any leftover credit users had before v2 launched and
// drains naturally as users place orders (the backend spends v1 first).
export const USDT_ESCROW_V2_ADDRESS = process.env.REACT_APP_USDT_ESCROW_V2_ADDRESS || '';

// Effective deposit target — v2 if configured, else fall back to v1.
// Lets the frontend flip back to v1-only by unsetting the v2 env var.
export const USDT_DEPOSIT_ADDRESS = USDT_ESCROW_V2_ADDRESS || USDT_ESCROW_ADDRESS;

